import React from 'react';
import { useTranslation } from 'react-i18next';
import ListItemRadioButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemRadioButton';
import { ReportSectionForms, ReportSectionTypes } from '../redux/constants';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from '../ReportPage.scss';
const MONETIZED_FORM_SECTION = ReportSectionForms[ReportSectionTypes.MonetizedAi];
const ReportHome = ({ data, onChange })=>{
    var _data_activeTypes;
    const { t } = useTranslation();
    // TODO: we should render all the radios here using the activeTypes returned from BE PAPI init
    const canReportMonetizedAi = data === null || data === void 0 ? void 0 : (_data_activeTypes = data.activeTypes) === null || _data_activeTypes === void 0 ? void 0 : _data_activeTypes.some((reportType)=>reportType.formId === MONETIZED_FORM_SECTION);
    return /*#__PURE__*/ React.createElement("ul", {
        className: s['section']
    }, /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.Block,
        label: t('moderation.option.dontWantToSeeThis'),
        onChange: (e)=>onChange(ReportSectionTypes.Block, true)
    }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.Inappropriate,
        label: t('moderation.option.inappropriate'),
        onChange: (e)=>onChange(ReportSectionTypes.Inappropriate)
    }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.IpViolation,
        label: t('moderation.option.intellectual'),
        onChange: (e)=>onChange(ReportSectionTypes.IpViolation)
    }), canReportMonetizedAi && /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.MonetizedAi,
        label: t('moderation.option.monetizedAi'),
        onChange: (e)=>onChange(ReportSectionTypes.MonetizedAi)
    }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.SomethingElse,
        label: t('moderation.option.somethingElse'),
        onChange: (e)=>onChange(ReportSectionTypes.SomethingElse)
    }));
};
ReportHome.displayName = 'ReportHome';
export default ReportHome;

//# sourceMappingURL=ReportHome.js.map